<div class="banners">
  <div class="slides" #slider>
    <ng-container *ngFor="let slide of slides;let i = index">
      <div class="slide" *ngIf="current === i" [@slideInOut] [@.disabled]="!loaded">
        <a [href]="slide.link | safe: 'url'" target="_blank">
          <img [src]="slide.picture.path">
        </a>
      </div>
    </ng-container>
  </div>
  <div class="navigation" *ngIf="slides.length > 1">
    <a href="javascript:;" class="previous" (click)="prev()">
      <mtg-svg-icon icon="icons-arrow-left"></mtg-svg-icon>
    </a>
    <div class="current">{{ current + 1 }} / {{ slides.length }}</div>
    <a href="javascript:;" class="next" (click)="next()">
      <mtg-svg-icon icon="icons-arrow-right"></mtg-svg-icon>
    </a>
  </div>
</div>
